/**
 * Popup de cupom DTX — cupom só para cliente logado.
 */
(() => {
  const root = document.querySelector('[data-dtx-coupon-popup]');
  if (!root) return;

  const dialog = root.querySelector('[data-dtx-coupon-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const storageKey = root.dataset.storageKey || 'dtx-coupon-popup';
  const frequency = root.dataset.frequency || 'once';
  const delayMs = Math.max(0, Number(root.dataset.delay || 800));
  const couponCode = (root.dataset.coupon || '').trim();
  const isLoggedIn = root.dataset.loggedIn === 'true';

  const dismissed = () => {
    try {
      if (frequency === 'always') return false;
      if (frequency === 'session') return sessionStorage.getItem(storageKey) === '1';
      return localStorage.getItem(storageKey) === '1';
    } catch {
      return false;
    }
  };

  const markDismissed = () => {
    try {
      if (frequency === 'always') return;
      if (frequency === 'session') sessionStorage.setItem(storageKey, '1');
      else localStorage.setItem(storageKey, '1');
    } catch {
      /* ignore */
    }
  };

  const openPopup = () => {
    if (dialog.open || dismissed()) return;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
  };

  const closePopup = () => {
    if (!dialog.open) return;
    dialog.close();
    document.documentElement.style.overflow = '';
    markDismissed();
  };

  root.querySelectorAll('[data-dtx-coupon-close]').forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      closePopup();
    });
  });

  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    closePopup();
  });

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) closePopup();
  });

  const copyCoupon = async () => {
    if (!isLoggedIn || !couponCode) return false;
    try {
      await navigator.clipboard.writeText(couponCode);
      return true;
    } catch {
      const input = document.createElement('input');
      input.value = couponCode;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      const ok = document.execCommand('copy');
      input.remove();
      return ok;
    }
  };

  const copyBtn = root.querySelector('[data-dtx-coupon-copy]');
  const feedback = root.querySelector('[data-dtx-coupon-feedback]');
  const registerLink = root.querySelector('[data-dtx-coupon-register]');

  if (copyBtn && isLoggedIn && couponCode) {
    copyBtn.addEventListener('click', async () => {
      const ok = await copyCoupon();

      if (feedback) {
        feedback.hidden = !ok;
        feedback.textContent = ok
          ? feedback.dataset.success || 'Cupom copiado!'
          : feedback.dataset.error || 'Não foi possível copiar';
        window.clearTimeout(copyBtn._dtxFeedbackTimer);
        copyBtn._dtxFeedbackTimer = window.setTimeout(() => {
          feedback.hidden = true;
          if (ok) copyBtn.textContent = copyBtn.dataset.label || copyBtn.textContent;
          copyBtn.classList.remove('is-copied');
        }, 2200);
      }

      if (ok) {
        copyBtn.textContent = copyBtn.dataset.copiedLabel || 'Cupom copiado!';
        copyBtn.classList.add('is-copied');
      } else {
        copyBtn.classList.remove('is-copied');
      }
    });
  }

  if (registerLink) {
    registerLink.addEventListener('click', () => {
      // Não revela o cupom antes do cadastro; só fecha o estado de visitante.
      markDismissed();
    });
  }

  if (!dismissed()) {
    window.setTimeout(openPopup, delayMs);
  }
})();
